import { render } from "./OrdersList.vue?vue&type=template&id=7fc32b73&scoped=true"
import script from "./OrdersList.vue?vue&type=script&lang=js"
export * from "./OrdersList.vue?vue&type=script&lang=js"

import "./OrdersList.vue?vue&type=style&index=0&id=7fc32b73&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fc32b73"]])

export default __exports__